import { render, staticRenderFns } from "./SharingTokenEditModal.vue?vue&type=template&id=0dca92c4&scoped=true&"
import script from "./SharingTokenEditModal.vue?vue&type=script&lang=js&"
export * from "./SharingTokenEditModal.vue?vue&type=script&lang=js&"
import style0 from "./SharingTokenEditModal.vue?vue&type=style&index=0&id=0dca92c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca92c4",
  null
  
)

/* custom blocks */
import block0 from "./SharingTokenEditModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports